export const roundValue = (value: number) => parseFloat((value * 1).toFixed(1))
